import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { GastosCreateComponent } from '../gastos-create/gastos-create.component';
import { GastosUpdateComponent } from '../gastos-update/gastos-update.component';
import { GastosViewComponent } from '../gastos-view/gastos-view.component';
import { GastosService } from '../gastos.service';
import { TipoGastosService } from '../../tipo-gastos/tipo-gastos.service';

@Component({
  selector: 'app-gastos-index',
  templateUrl: './gastos-index.component.html',
  styleUrls: ['./gastos-index.component.scss']
})
export class GastosIndexComponent implements OnInit {
  reloadEmitter: EventEmitter<string> = new EventEmitter();
  constructor(
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    private modalService: NgbModal,
    public service: GastosService,
    public sesion: SesionService,
    public tipoGastosService: TipoGastosService
  ) {
    this.loadTipoGasto()
  }
  columnas: any[] = [
    {
      label: "Fecha",
      attribute: 'fecha',
      width: 1,
      responsive: ['SM', 'MD'],
      value: (el: any) => {
        return this.formatter.dateFormat(el.fecha);
      }
    },
    {
      label: "Tipo",
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      attribute: "tipo",
      value: (el: any) => {
        return el.tipo_gasto?.nombre;
      }
    },
    {
      label: "Monto",
      attribute: "monto",
      responsive: ['XS', 'SM', 'MD'],
      width: 1,
      value: (element: any, index: number) => {
        return '$ ' + this.formatter.numberFormat(element.monto);
      }
    },
    {
      label: "Detalle",
      responsive: ['MD'],
      width: 2,
      attribute: "detalle",

    }
  ]
  acciones: any[] = [
    {
      label: 'Detalle',
      icon: 'eye',
      action: (element: any, index: number) => {
        this.view(element.id);
      }
    },
    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any, index: number) => {
        this.update(element);
      }
    }
    ,
    {
      label: 'Elinimar',
      icon: 'trash',
      action: (element: any, index: number) => {
        this.delete(element);
      }
    }

  ]

  filtros: any[] = [
    {
      label: 'Desde',
      column: 'fecha',
      op: 'gte',
      type: 'date'
    },
    {
      label: 'Hasta',
      column: 'fecha',
      op: 'lte',
      type: 'date'
    },
    {
      label: 'Monto',
      op: 'substring',
      column: 'monto',
      type: 'number'
    },
    {
      label: 'Tipo de Gasto',
      column: 'tipo_gasto_id',
      op: 'eq',
      type: 'select',
      options: [] as { label: string; value: number; }[],
    },
    {
      label: 'Detalle',
      op: 'substring',
      column: 'detalle'
    }
  ]

  ngOnInit(): void {
  }
  agregar() {
    this.modalService.open(GastosCreateComponent, { size: 'lg', scrollable: true, backdrop: 'static' }).result.then((result: any) => {
      this.reloadEmitter.emit('true');
    }, (reason: any) => { });
  }

  view(id: number) {
    this.loading.show()
    this.service.view(id).subscribe((res: any) => {
      this.loading.hide();
      const modalRef = this.modalService.open(GastosViewComponent, { size: 'lg', scrollable: true });
      modalRef.componentInstance.element = res
      modalRef.result.then((result) => { }, (reason) => { });
    })

  }

  update(element: any) {
    this.loading.show()
    this.service.view(element.id).subscribe({
      next: (res) => {
        this.loading.hide();
        let modalRef = this.modalService.open(GastosUpdateComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
        modalRef.componentInstance.element = res;
        modalRef.result.then((result: any) => {
          this.reloadEmitter.emit('true');
        }, (reason: any) => { });
      }, error: (err) => {
        this.loading.hide();
        if (err.error) this.formatter.showErrorAlerts(err.error);
      }
    });
  }

  delete(element: any) {
    let modalRef = this.modalService.open(ModalDeleteComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Gasto';
    modalRef.componentInstance.texto = `¿Está seguro de que desea eliminar el gasto #${element.id} con fecha ${this.formatter.dateFormat(element.fecha)} y monto \$ ${this.formatter.numberFormat(element.monto)}?`;
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result: any) => {
      this.loading.show()
      this.service.delete(element.id).subscribe({
        next: (res) => {
          this.loading.hide();
          this.reloadEmitter.emit('true');
          this.alerts.addAlert('El Gasto se eliminó con éxito.', 'success');
        },
        error: err => {
          this.loading.hide();
          if (err.error) this.formatter.showErrorAlerts(err.error);
        }
      });
    }, (reason: any) => { });
  }

  loadTipoGasto() {
    this.loading.show()
    let user = JSON.parse(localStorage.getItem('usuario') as string);
    this.tipoGastosService.select(user).subscribe({
      next: (res) => {
        this.loading.hide();
        for (let i = 0; i < res.length; i++) {
          this.filtros[3].options?.push({ label: res[i].nombre, value: res[i].id })
        }
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo cargar los tipos de gastos de la empresa", "danger");
        if (err.error.response) {
          this.alerts.addAlert(err.error.response, "danger");
        }
      }
    });
  }
}
